import { Injectable } from '@angular/core';
import { Section, WorkflowConfig } from 'classes-lib';
import { SectionType } from 'enums-lib';
import { SectionFileDatasourceService } from 'file-datasource-service-lib';
import { IWorkflowConfig } from 'interfaces-lib';
import { jwtDecode } from 'jwt-decode';
import { IdentityStorage } from 'storage-service-lib';

@Injectable({
  providedIn: 'root',
})
export class WorkflowConfigCopyService {
  constructor(private identityStorage: IdentityStorage, private sectionService: SectionFileDatasourceService) {}

  async copy(workflowConfig: IWorkflowConfig): Promise<IWorkflowConfig> {
    const copy: IWorkflowConfig = WorkflowConfig.clone(workflowConfig);
    await this.downloadFiles(copy); // relies on workflow config id and section id
    copy.id = undefined;
    copy.name = `COPY OF ${copy.name}`;
    copy.isPublic = false;
    copy.sections.forEach((s) => (s.id = undefined));
    copy.createdBy = this.getUsername();
    copy.dateCreated = new Date();
    copy.modifiedBy = this.getUsername();
    copy.dateModified = new Date();
    return copy;
  }

  private async downloadFiles(copy: IWorkflowConfig): Promise<void> {
    const sectionsWithFiles = [
      SectionType.DocxTemplate,
      SectionType.HtmlDocxTemplate,
      SectionType.FixedFile
    ];
    const hasSectionFile = (section: Section) => sectionsWithFiles.includes(section.type) && section.sourceValue;
    const templateSections = copy.sections.filter((section) => hasSectionFile(section));
    for (const section of templateSections) {
      const blob = await this.sectionService.downloadSectionFile(copy.id, section.id, section.sourceValue).toPromise();
      section['file'] = new File([blob], section.sourceValue);
    }
  }

  private getUsername(): string {
    const decoded = jwtDecode<any>(this.identityStorage.get().token);
    return decoded.name;
  }
}
